import { useState, type FormEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLogin } from './hooks';
import { Button, Input, Label, Card, CardHeader, CardTitle, CardDescription, CardContent, ApiError } from '@smena/ui';

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const loginMut = useLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await loginMut.mutateAsync({ email, password });
      const next = new URLSearchParams(location.search).get('next') ?? '/';
      navigate(next, { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setError('Неверный email или пароль');
      } else {
        setError('Ошибка входа, попробуйте ещё раз');
      }
    }
  }

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 p-6">
      <div className="flex items-center gap-2.5 text-lg font-bold tracking-tight">
        <i className="size-2.5 rounded-full bg-accent shadow-[0_0_0_4px_rgba(21,94,239,.22)]" />
        <span>Smena</span>
      </div>
      <Card className="w-full max-w-sm shadow-pop">
        <CardHeader>
          <CardTitle className="text-lg">Панель управления</CardTitle>
          <CardDescription className="text-sm">
            Войдите под своей учётной записью - доступ выдаёт владелец аккаунта.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} autoComplete="on" noValidate className="flex flex-col gap-3">
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                autoComplete="username"
                autoFocus
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="password">Пароль</Label>
              <Input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <Button type="submit" size="lg" disabled={loginMut.isPending} className="mt-3">
              {loginMut.isPending ? 'Проверяем…' : 'Войти'}
            </Button>
            {error ? (
              <div
                role="alert"
                aria-live="polite"
                className="rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive"
              >
                {error}
              </div>
            ) : null}
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
